import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomIconGoogleStore = (props: {}): JSX.Element => (
    <SvgIcon {...props}>
        <path
            d={
                'M18.9491 11.3487L15.7098 9.45654L13.0459 12.0633L15.4805 14.4459L18.9491 12.4194C19.14 12.3079 19.2541 12.1079 19.2541 11.8843C19.2541 11.6608 19.14 11.4608 18.9491 11.3487Z'
            }
        />
        <path d={'M15.159 9.13495L11.5938 7.05243L3.78174 3L12.6052 11.6336L15.159 9.13495Z'} />
        <path d={'M3.91357 20.9999L11.6093 16.7085L14.9311 14.7672L12.6072 12.4932L3.91357 20.9999Z'} />
        <path d={'M3.26238 3.34912L3.25391 20.7856L12.1683 12.0634L3.26238 3.34912Z'} />
    </SvgIcon>
);
